import { lazy, useEffect } from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { themeChange } from 'theme-change'
import initializeApp from './app/init';
import {useDispatch} from "react-redux";
import {setUserInfoFromStorage} from "./features/common/userSlice";
import { DialogProvider } from './components/Dialog';
import { getFirstRoutePath } from './config/routes.config';
import checkAuth from "./app/auth";

// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))

// Initializing different libraries
initializeApp()

// Check for login and initialize axios
const token = checkAuth()


function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    themeChange(false)
    dispatch(setUserInfoFromStorage());
  }, [dispatch])


  // ROUTES_CONFIG의 첫 번째 라우트 경로 가져오기
  const firstRoutePath = getFirstRoutePath();

  return (
    <DialogProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to={firstRoutePath} replace />} />
          <Route path="/login" element={<Login />} />

          {/* Place new routes over this */}
          <Route path="/*" element={<Layout />} />

          <Route path="*" element={<Navigate to={token ? firstRoutePath : '/login'} replace />}/>

        </Routes>
      </Router>
    </DialogProvider>
  )
}

export default App
